import { BaseTable, Loading, PermissionLink, TableHeader } from "components";
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils";
import { Fragment } from "react";
import { IoSendSharp } from "react-icons/io5";
import { convertNumber } from "utils";
import { useList } from "./hooks";
import { SummarySection } from "pages/Inventori/Transaction/components";

export function TabInvoice(props: {disable?: boolean, dateFrom:string, dateEnd:string }) {
  const productId = localStorage?.getItem("prdId")
  const { data, isLoading } = useList(Number(productId), props.dateFrom, props.dateEnd)

  const totalQty = data.reduce((total, item) => { return total + (item?.quantity_invoice ? item?.quantity_invoice : 0)}, 0);
  const totalExt = data.reduce((total, item) => { return total + (item?.total ? item?.total : 0)}, 0);
  const totalAverage = (totalExt || 0) / (totalQty || 0)

  return (
    <Fragment>
      <section className="mt-2">
        <div className="overflow-x-auto">
          <BaseTable className="border-transparent">
            <TableHeader>
              <tr className="uppercase">
                <th>No</th>
                <th colSpan={props?.disable ? 1 : 2}>INVOICE ID</th>
                <th>Date</th>
                <th>Customer</th>
                <th>Qty</th>
                <th>Unit</th>
                <th>Price</th>
                <th>Disc</th>
                <th>Ext</th>
              </tr>
            </TableHeader>
            <tbody>
              {!data.length || isLoading
                ? <tr><td colSpan={15} className="text-center"><Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} /></td></tr>
                : data.map((val, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    { !props?.disable &&
                      <td>
                        <PermissionLink permission="IR013" to={`/sales/transaction/invoice/edit/${val.invoice_id}`}>
                          <IoSendSharp />
                        </PermissionLink>
                      </td>
                    }
                    <td>{val?.trx_code ?? ""}</td>
                    <td>{val?.transaction_date ? convertDate(val?.transaction_date) : "-"}</td>
                    <td>{val?.customer.customer_name ?? "-"}</td>
                    <td className="text-center">{val?.quantity_invoice ? convertNumber(val?.quantity_invoice)?.intoNormalAmount : "-"}</td>
                    <td>{val?.unit.mr_unit_name ?? "-"}</td>
                    <td className="text-right">{val?.price_invoice ? convertNumber(val?.price_invoice)?.intoCurrency : "-"}</td>
                    <td className="text-center">{val?.discount ? `${convertNumber(val?.discount)?.intoNormalAmount}%` : "-"}</td>
                    <td className="text-right">{val?.total ? convertNumber(val?.total)?.intoCurrency : "-"}</td>
                  </tr>
                ))
              }
              <tr className="font-bold">
                <td colSpan={5} className="text-right">SUMMARY QTY</td>
                <td className="text-center">{totalQty ? convertNumber(totalQty)?.intoNormalAmount : "0"}</td>
                <td colSpan={3} className="text-right">SUMMARY EXT</td>
                <td className="text-right">{totalExt ? convertNumber(totalExt)?.intoCurrency : "0"}</td>
              </tr>
            </tbody>
          </BaseTable>
        </div>
        <div className="flex justify-end mt-4">
          <div className="min-w-[300px]">
            <SummarySection
              label="AVERAGE"
              value={totalAverage ? convertNumber(totalAverage)?.intoCurrency : "0"}
            />
          </div>
        </div>
      </section>
    </Fragment>
  )
}